import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { auth } from '../firebase';
import { useAuth } from '../context/AuthContext';
import apiService from '../services/apiService';
import { OTPInput } from '../components';

const COUNTRY_CODES = [
  { code: '+1',    flag: '🇺🇸', label: 'United States',  short: 'US' },
  { code: '+91',   flag: '🇮🇳', label: 'India',          short: 'IN' },
  { code: '+44',   flag: '🇬🇧', label: 'United Kingdom', short: 'UK' },
  { code: '+61',   flag: '🇦🇺', label: 'Australia',      short: 'AU' },
  { code: '+971',  flag: '🇦🇪', label: 'UAE',            short: 'AE' },
  { code: '+65',   flag: '🇸🇬', label: 'Singapore',      short: 'SG' },
  { code: '+60',   flag: '🇲🇾', label: 'Malaysia',       short: 'MY' },
  { code: '+92',   flag: '🇵🇰', label: 'Pakistan',       short: 'PK' },
  { code: '+880',  flag: '🇧🇩', label: 'Bangladesh',     short: 'BD' },
  { code: '+86',   flag: '🇨🇳', label: 'China',          short: 'CN' },
  { code: '+81',   flag: '🇯🇵', label: 'Japan',          short: 'JP' },
  { code: '+82',   flag: '🇰🇷', label: 'South Korea',    short: 'KR' },
  { code: '+66',   flag: '🇹🇭', label: 'Thailand',       short: 'TH' },
  { code: '+84',   flag: '🇻🇳', label: 'Vietnam',        short: 'VN' },
  { code: '+62',   flag: '🇮🇩', label: 'Indonesia',      short: 'ID' },
  { code: '+63',   flag: '🇵🇭', label: 'Philippines',    short: 'PH' },
  { code: '+966',  flag: '🇸🇦', label: 'Saudi Arabia',   short: 'SA' },
  { code: '+974',  flag: '🇶🇦', label: 'Qatar',          short: 'QA' },
  { code: '+965',  flag: '🇰🇼', label: 'Kuwait',         short: 'KW' },
  { code: '+968',  flag: '🇴🇲', label: 'Oman',           short: 'OM' },
  { code: '+973',  flag: '🇧🇭', label: 'Bahrain',        short: 'BH' },
  { code: '+20',   flag: '🇪🇬', label: 'Egypt',          short: 'EG' },
  { code: '+234',  flag: '🇳🇬', label: 'Nigeria',        short: 'NG' },
  { code: '+254',  flag: '🇰🇪', label: 'Kenya',          short: 'KE' },
  { code: '+27',   flag: '🇿🇦', label: 'South Africa',   short: 'ZA' },
  { code: '+44',   flag: '🇨🇦', label: 'Canada',         short: 'CA' },
  { code: '+1',    flag: '🇲🇽', label: 'Mexico',         short: 'MX' },
  { code: '+55',   flag: '🇧🇷', label: 'Brazil',         short: 'BR' },
  { code: '+56',   flag: '🇨🇱', label: 'Chile',          short: 'CL' },
  { code: '+34',   flag: '🇪🇸', label: 'Spain',          short: 'ES' },
  { code: '+33',   flag: '🇫🇷', label: 'France',         short: 'FR' },
  { code: '+49',   flag: '🇩🇪', label: 'Germany',        short: 'DE' },
  { code: '+39',   flag: '🇮🇹', label: 'Italy',          short: 'IT' },
  { code: '+31',   flag: '🇳🇱', label: 'Netherlands',    short: 'NL' },
  { code: '+46',   flag: '🇸🇪', label: 'Sweden',         short: 'SE' },
  { code: '+47',   flag: '🇳🇴', label: 'Norway',         short: 'NO' },
  { code: '+41',   flag: '🇨🇭', label: 'Switzerland',    short: 'CH' },
  { code: '+43',   flag: '🇦🇹', label: 'Austria',        short: 'AT' },
  { code: '+32',   flag: '🇧🇪', label: 'Belgium',        short: 'BE' },
  { code: '+45',   flag: '🇩🇰', label: 'Denmark',        short: 'DK' },
  { code: '+358',  flag: '🇫🇮', label: 'Finland',        short: 'FI' },
  { code: '+353',  flag: '🇮🇪', label: 'Ireland',        short: 'IE' },
  { code: '+48',   flag: '🇵🇱', label: 'Poland',         short: 'PL' },
  { code: '+30',   flag: '🇬🇷', label: 'Greece',         short: 'GR' },
  { code: '+36',   flag: '🇭🇺', label: 'Hungary',        short: 'HU' },
  { code: '+420',  flag: '🇨🇿', label: 'Czech Republic', short: 'CZ' },
  { code: '+40',   flag: '🇷🇴', label: 'Romania',        short: 'RO' },
  { code: '+7',    flag: '🇷🇺', label: 'Russia',         short: 'RU' },
  { code: '+380',  flag: '🇺🇦', label: 'Ukraine',        short: 'UA' },
  { code: '+90',   flag: '🇹🇷', label: 'Turkey',         short: 'TR' },
  { code: '+212',  flag: '🇲🇦', label: 'Morocco',        short: 'MA' },
  { code: '+216',  flag: '🇹🇳', label: 'Tunisia',        short: 'TN' },
  { code: '+1',    flag: '🇮🇨', label: 'Iceland',        short: 'IS' },
];

const LoginPage = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  const [selectedCountry, setSelectedCountry]     = useState(COUNTRY_CODES[1]); // default India
  const [showCountryPicker, setShowCountryPicker] = useState(false);
  const [countrySearch, setCountrySearch]         = useState('');
  const [phoneNumber, setPhoneNumber]             = useState('');
  const [otp, setOtp]                             = useState('');
  const [step, setStep]                           = useState('phone');
  const [isLoading, setIsLoading]                 = useState(false);
  const [countdown, setCountdown]                 = useState(0);
  const [error, setError]                         = useState('');
  const confirmationResultRef = useRef(null);
  const verifierRef           = useRef(null);
  const [registerData, setRegisterData] = useState({ first_name: '', last_name: '', email: '' });
  const firebaseIdTokenRef = useRef('');

  // ─── Redirect if already logged in ───────────────────────────────────────
  useEffect(() => {
    if (isAuthenticated) navigate('/customer');
  }, [isAuthenticated, navigate]);

  // ─── Countdown timer ──────────────────────────────────────────────────────
  useEffect(() => {
    if (countdown > 0) {
      const t = setTimeout(() => setCountdown(c => c - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [countdown]);

  // ─── Cleanup verifier on unmount ──────────────────────────────────────────
  useEffect(() => {
    return () => {
      if (verifierRef.current) {
        try { verifierRef.current.clear(); } catch (_) {}
        verifierRef.current = null;
      }
    };
  }, []);

  // ─── Phone helpers ────────────────────────────────────────────────────────
  const formatPhoneUS = (phone) => {
    const c = phone.replace(/\D/g, '');
    if (c.length <= 3) return c;
    if (c.length <= 6) return `(${c.slice(0,3)}) ${c.slice(3)}`;
    return `(${c.slice(0,3)}) ${c.slice(3,6)}-${c.slice(6,10)}`;
  };

  const handlePhoneChange = (text) => {
    const cleaned = text.replace(/\D/g, '').slice(0, 10);
    setPhoneNumber(selectedCountry.code === '+1' ? formatPhoneUS(cleaned) : cleaned);
  };

  const getCleanPhone = () => phoneNumber.replace(/\D/g, '');
  const getE164Phone  = () => `${selectedCountry.code}${getCleanPhone()}`;
  const isPhoneValid  = () => getCleanPhone().length >= 7;

  const filteredCountries = COUNTRY_CODES.filter(c =>
    c.label.toLowerCase().includes(countrySearch.toLowerCase()) || c.code.includes(countrySearch)
  );

  // ─── Create fresh invisible reCAPTCHA verifier ────────────────────────────
  const getVerifier = () => {
    if (verifierRef.current) {
      try { verifierRef.current.clear(); } catch (_) {}
      verifierRef.current = null;
    }
    verifierRef.current = new RecaptchaVerifier(auth, 'recaptcha-container', {
      size: 'invisible',
    });
    return verifierRef.current;
  };

  // ─── Step 1: Send OTP ─────────────────────────────────────────────────────
  const handleSendOTP = async () => {
    if (!isPhoneValid()) { setError('Please enter a valid phone number'); return; }
    setError('');
    setIsLoading(true);
    try {
      const verifier = getVerifier();
      console.log('[OTP] Sending to', getE164Phone());
      const confirmationResult = await signInWithPhoneNumber(auth, getE164Phone(), verifier);
      confirmationResultRef.current = confirmationResult;
      console.log('[OTP] Sent successfully');
      setStep('otp');
      setCountdown(60);
    } catch (e) {
      console.error('[OTP] sendOTP error:', e.code, e.message);
      if (verifierRef.current) {
        try { verifierRef.current.clear(); } catch (_) {}
        verifierRef.current = null;
      }
      if (e.code === 'auth/invalid-phone-number') {
        setError('Invalid phone number. Please check the number and country code.');
      } else if (e.code === 'auth/too-many-requests') {
        setError('Too many attempts. Please wait a few minutes and try again.');
      } else if (e.code === 'auth/captcha-check-failed' || e.code === 'auth/invalid-app-credential') {
        setError('Domain not authorized. Add this domain in Firebase Console → Authentication → Authorized Domains.');
      } else if (e.code === 'auth/quota-exceeded') {
        setError('SMS quota exceeded. Please try again later.');
      } else {
        setError(e.message || 'Failed to send OTP. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // ─── Step 2: Verify OTP ───────────────────────────────────────────────────
  const handleVerifyOTP = async () => {
    if (otp.length < 6) { setError('Please enter the 6-digit code'); return; }
    if (!confirmationResultRef.current) { setError('Session expired. Please go back and resend OTP.'); return; }
    setError('');
    setIsLoading(true);
    try {
      const userCredential  = await confirmationResultRef.current.confirm(otp);
      const firebaseIdToken = await userCredential.user.getIdToken();

      const res = await apiService.firebasePhoneAuth(firebaseIdToken);
      if (!res.success) { setError(res.error || 'Authentication failed. Please try again.'); return; }

      const data = res.data || {};
      if (data.is_new_user) {
        firebaseIdTokenRef.current = firebaseIdToken;
        setStep('register');
      } else {
        login(data.access_token, data.customer || {});
        navigate('/customer');
      }
    } catch (e) {
      console.error('Firebase verify error:', e.code, e.message);
      if (e.code === 'auth/invalid-verification-code') {
        setError('Incorrect OTP. Please check and try again.');
      } else if (e.code === 'auth/code-expired') {
        setError('OTP has expired. Please go back and request a new code.');
      } else {
        setError(e.message || 'Verification failed. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // ─── Step 3: Complete registration (new users) ────────────────────────────
  const handleCompleteRegistration = async () => {
    if (!registerData.first_name.trim()) { setError('First name is required'); return; }
    if (!registerData.last_name.trim())  { setError('Last name is required');  return; }
    setError('');
    setIsLoading(true);
    try {
      const res = await apiService.completeFirebaseRegistration({
        firebase_token: firebaseIdTokenRef.current,
        first_name: registerData.first_name.trim(),
        last_name:  registerData.last_name.trim(),
        country_code: selectedCountry.code,
      });
      if (res.success) {
        login(res.data?.access_token, res.data?.customer || {});
        navigate('/customer');
      } else {
        setError(res.error || 'Registration failed. Please try again.');
      }
    } catch (e) {
      setError('Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div className="auth-page">
      {/* Invisible reCAPTCHA anchor — must always be in the DOM */}
      <div id="recaptcha-container" />

      <div className="auth-card">

        {/* Logo */}
        <div className="auth-logo">
          <span className="auth-logo-icon">🍛</span>
          <h1 className="auth-brand">Biryani</h1>
          <p className="auth-tagline">Authentic Home Kitchens</p>
        </div>

        {/* ── Step: phone ── */}
        {step === 'phone' && (
          <>
            <h2 className="auth-title">Welcome Back</h2>
            <p className="auth-subtitle">Enter your phone number to continue</p>

            <div className="phone-input-wrapper">
              <button className="country-code-btn" onClick={() => setShowCountryPicker(true)}>
                {selectedCountry.flag} {selectedCountry.code}
              </button>
              <input
                type="tel"
                className="phone-input"
                placeholder="Phone number"
                value={phoneNumber}
                onChange={(e) => handlePhoneChange(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSendOTP()}
              />
            </div>

            {error && <p className="auth-error">{error}</p>}

            <button
              className="btn-primary btn-full"
              onClick={handleSendOTP}
              disabled={isLoading || !isPhoneValid()}
            >
              {isLoading ? 'Sending…' : 'Send OTP'}
            </button>

            <p className="auth-footer-text">
              By continuing, you agree to our{' '}
              <a href="/terms" target="_blank" rel="noreferrer">Terms</a> and{' '}
              <a href="/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>
            </p>
          </>
        )}

        {/* ── Step: otp ── */}
        {step === 'otp' && (
          <>
            <button className="back-btn" onClick={() => { setStep('phone'); setOtp(''); setError(''); }}>
              ← Back
            </button>
            <h2 className="auth-title">Verify OTP</h2>
            <p className="auth-subtitle">
              We sent a 6-digit code to {selectedCountry.code} {phoneNumber}
            </p>

            <OTPInput length={6} value={otp} onChange={setOtp} />

            {error && <p className="auth-error">{error}</p>}

            <button
              className="btn-primary btn-full"
              onClick={handleVerifyOTP}
              disabled={isLoading || otp.length < 6}
            >
              {isLoading ? 'Verifying…' : 'Verify'}
            </button>

            <div className="resend-row">
              {countdown > 0 ? (
                <span className="resend-countdown">Resend in {countdown}s</span>
              ) : (
                <button className="resend-btn" onClick={() => { setStep('phone'); setOtp(''); setError(''); }} disabled={isLoading}>
                  ← Change number / Resend
                </button>
              )}
            </div>
          </>
        )}

        {/* ── Step: register ── */}
        {step === 'register' && (
          <>
            <h2 className="auth-title">Create Account</h2>
            <p className="auth-subtitle">Just a few more details to get started</p>

            <div className="form-group">
              <label className="form-label">First Name *</label>
              <input
                type="text"
                className="form-input"
                placeholder="First name"
                value={registerData.first_name}
                onChange={(e) => setRegisterData(d => ({ ...d, first_name: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Last Name *</label>
              <input
                type="text"
                className="form-input"
                placeholder="Last name"
                value={registerData.last_name}
                onChange={(e) => setRegisterData(d => ({ ...d, last_name: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Email (optional)</label>
              <input
                type="email"
                className="form-input"
                placeholder="your@email.com"
                value={registerData.email}
                onChange={(e) => setRegisterData(d => ({ ...d, email: e.target.value }))}
              />
            </div>

            {error && <p className="auth-error">{error}</p>}

            <button
              className="btn-primary btn-full"
              onClick={handleCompleteRegistration}
              disabled={isLoading || !registerData.first_name.trim()}
            >
              {isLoading ? 'Creating account…' : 'Create Account'}
            </button>
          </>
        )}
      </div>

      {/* ── Country Picker Modal ── */}
      {showCountryPicker && (
        <div className="modal-overlay" onClick={() => setShowCountryPicker(false)}>
          <div className="modal-container modal-medium" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Select Country</h3>
              <button className="modal-close" onClick={() => setShowCountryPicker(false)}>✕</button>
            </div>
            <div className="modal-body">
              <input
                type="text"
                className="form-input"
                placeholder="Search country…"
                value={countrySearch}
                onChange={(e) => setCountrySearch(e.target.value)}
                autoFocus
              />
              <div className="country-list">
                {filteredCountries.map((c) => (
                  <button
                    key={c.code}
                    className={`country-item ${selectedCountry.code === c.code ? 'selected' : ''}`}
                    onClick={() => { setSelectedCountry(c); setShowCountryPicker(false); setCountrySearch(''); }}
                  >
                    <span>{c.flag}</span>
                    <span>{c.label}</span>
                    <span className="country-code">{c.code}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
